import { Attribute, Relationship, Resource } from 'json-api'
import { AtomResource } from '../classes/atom-resource'
import { BillingPolicy } from './billing-policy'
import { Offer } from './offer.resource'
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config'
import { BillingPolicyConfig } from 'src/app/shared/tools/search/search-config'
import { AtomService } from '../atom.service'

@Resource({
  type: 'offerbillingpolicy',
})
export class OfferBillingPolicy extends AtomResource {
  @Attribute({key: 'subscription_date'}) subscriptionDate?: string;
  @Attribute({key: 'validity_tz'}) validityTz?: string;
  @Attribute() validity?: string;

  @Relationship() offer?: Offer;
  @Relationship() billingpolicy?: BillingPolicy;
}
export class OfferBillingPolicyConfig implements ResourceConfig {
  hosted = 'offer';
  tables = {
    options: {
      copy: true,
    },
    includes: ['offer', 'billingpolicy'],
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main' }],
        header: 'ID',
        displayed: true,
        sort: 'id',
      },
      {
        columnDef: 'status',
        header: 'Validity',
        displayed: true,
      },
      {
        columnDef: 'billingpolicy',
        displayedDatas: [
          { path: ['billingpolicy.name'], class: 'main' },
        ],
        header: 'Billing Policy',
        displayed: true,
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        displayed: true,
      },
    ],
  };
  detail = {
    header: {
      icon: 'shield',
      title: [
        {
          path: ['offer.name', 'billingpolicy.name'],
          translatable: false,
        },
      ],
      id: true,
      validity: true,
    },
    elements: [
      {
        showEmpty: true,
        list: [
          {
            icon: 'local_offer',
            title: 'Offer',
            APIKey: 'offer',
            value: {
              path: ['offer.name'],
            },
          },
          {
            icon: 'shield',
            title: 'Billing Policy',
            APIKey: 'billingpolicy',
            value: {
              path: ['billingpolicy.name'],
            },
          },
          // {
          //   title: 'Subscription Date',
          //   APIKey: 'subscriptionDate',
          //   value: {
          //     path: ['subscriptionDate'],
          //   },
          // },
        ],
      },
    ],
  };
  wizard = {
    noSummary: true,
    tabs: [
      {
        title: 'Offer Billing Policy',
        formGroup: 'general',
        list: [
          {
            type: 'resource',
            title: 'Billing Policy',
            formControl: 'billingpolicy',
            APIKey: 'billingpolicy',
            search: new BillingPolicyConfig(this.atom),
            required: true,
            noCols: true,
            filter: [
              {
                key: 'equal.country.id',
                value: 'offer.country.id'
              },
              {
                key: 'equal.enduserproviderjob.id',
                value: 'offer.enduserproviderjob.id'
              },
              {
                key: 'equal.platform.id',
                value: 'offer.platform.id'
              },
            ]
          },
          {
            type: 'validity',
            title: 'Validity',
            formControl: 'validity',
          },
        ]
      }
    ],
  };
  resource = OfferBillingPolicy;
  resourceName = 'Billing Policy';
  resourceKey = 'offerbillingpolicy';
  resourceKeySingle = 'offerbillingpolicy';
  includes = [
    'offer.enduserproviderjob',
    'offer.country',
    'offer.platform',
    'billingpolicy'
  ];
  constructor(private atom: AtomService) {}
}
